import React, { useState } from 'react';
import { Button } from '@cp/ds/src/components/button';
import { ArrowRightIcon } from '@cp/ds/src/icons';
import { Alert } from '@cp/ds/src/components/alert';
import { Box } from '@mui/material';
import { useIsMobile } from '@cp/ds/src/hooks/useIsMobile';
import { CareerId } from '@common/const/catalog/career';
import { MOBILE_BREAKPOINT_THRESHOLD } from '@cp/ds/src/theme';
import { isBrowser } from '@cp/utils/browser';
import { VideoPlayer, VideoPlayerCssTokens } from '@cp/ui';
import { StepHeader } from 'src/features/client/training/ui/stepHeader';
import { StepContainer } from '../stepContainer';
import { StepFooter } from '../stepFooter';
import { VideoStepProps } from './model';

/**
 * Force enable submit button on video steps to skip video.
 * Useful for testing purpose.
 */
const CLIENT_TRAINING_VIDEO_SUBMIT_ENABLE = isBrowser && Boolean(window['CLIENT_TRAINING_VIDEO_SUBMIT_ENABLE']);

export const VideoStep: React.FC<VideoStepProps> = ({ onSubmit, model, meta, showAlert }) => {
  const isMobile = useIsMobile();
  const [submitEnabled, setSubmitEnabled] = useState(CLIENT_TRAINING_VIDEO_SUBMIT_ENABLE);

  return (
    <>
      <StepContainer sx={{ flexGrow: 1 }}>
        <Box sx={{ display: 'flex', flexGrow: 1, flexDirection: 'column', gap: 2.5 }}>
          <StepHeader
            blockTitle={meta.title}
            careerId={CareerId.Nanny}
            stepAction="Посмотрите видео"
            stepNumber={meta.stepNumber}
            totalSteps={meta.totalSteps}
          />
          {showAlert && (
            <Alert icon="⚠️">
              После запуска видео нельзя будет поставить на паузу. После просмотра вы сможете пройти тест. Если вы закроете модальное окно,
              то видео нужно будет смотреть заново.
            </Alert>
          )}
          <Box>
            <VideoPlayer
              controls
              controlsList="nodownload noremoteplayback noplaybackrate nofullscreen"
              disablePictureInPicture
              onEnded={() => setSubmitEnabled(true)}
              preload="metadata"
              src={model.url}
              sx={{ borderRadius: '12px', [VideoPlayerCssTokens.stageColor]: '#405368' }}
            />
          </Box>
        </Box>
      </StepContainer>
      <StepFooter>
        <Button
          disabled={!submitEnabled}
          iconRight={isMobile ? undefined : <ArrowRightIcon />}
          onClick={() => onSubmit()}
          sx={{ width: { xs: 1, [MOBILE_BREAKPOINT_THRESHOLD]: 'auto' } }}
        >
          Пройти тест
        </Button>
      </StepFooter>
    </>
  );
};
